import { CoreApi } from '@inter-ikea-storageone/range';
import PanelSelection from '../types/PanelSelection';
import getPanelProductSelectionIds from './getPanelProductSelectionIds';
import { Entity } from '@inter-ikea-core/core';

const getPanelSelectedIds: (
  panelSelection: PanelSelection
) => (selectedEntity: Entity, coreApi: CoreApi) => string[] = panelSelection => {
  return (selectedEntity, coreApi) => {
    const panelProductSelectionIds = getPanelProductSelectionIds(selectedEntity, coreApi);
    if (!panelProductSelectionIds) {
      return [];
    }
    return [panelProductSelectionIds[panelSelection]];
  };
};

export default getPanelSelectedIds;
